import { createActions } from '../utils/actions';

const { actions: auth } = createActions('auth')
  .addAsync('commitPasswordReset')
  .addAsync('createAccount')
  .add('removeError')
  .addAsync('requestPasswordReset')
  .add('resetPasswordStatus')
  .add('setAffiliate')
  .add('setLoggedIn')
  .addAsync('signIn');

export default auth;
